import { combineReducers } from 'redux';
import form from './modules/form/form-reducer';
import auth from './modules/auth/auth-reducer';
import facility from './modules/facility/facility-reducer';
import capability from './modules/capability/capability-reducer';
import messageDisplayBar from './modules/system-shared/message-bar-reducer';
import language from './modules/language/language-reducer';
import patient from './modules/patient/patient-reducer';
import personalContacts from './modules/personal-contacts/personal-contacts-reducer';
import appointment from './modules/appointment/appointment-reducer';
import careTeam from './modules/care-team/care-team-reducer';
import user from './modules/user-profile/user-profile-reducer';
import secureMessage from './modules/secure-message/secure-message-reducer';
import testResults from './modules/test-results/test-results-reducer';
import audit from './modules/audit/audit-reducer';
import contactUs from './modules/contact-us/reducer';
import followUp from './modules/follow-up/reducer';
import education from './modules/education/education-reducer';
import window from './modules/window/window-reducer';
import medicalNotes from './modules/medical-notes/medical-notes-reducer';
import treatmentSummary from './modules/treatment-summary/treatment-summary-reducer';
import questionnaires from './modules/questionnaires/questionnaires-reducer';
import localization from './modules/localization/localization-reducer';
import healthSummary from './modules/health-summary/health-summary-reducer';
import externalSystems from './modules/external-systems/external-systems-reducer';
import workflow from './modules/workflow/workflow-reducer';
import accountSettings from './modules/account-settings/account-settings-reducer';
import signUp from './modules/signup/signup-reducer';
import lookups from './modules/lookups/lookups-reducer';
import invitation from './modules/ar-invitation/ar-invitation-reducer';
import loadingIndicator from './modules/loading-indicator/loading-indicator-reducer';
import * as LoginTypes from './modules/auth/auth-actiontypes';

const appReducer = combineReducers({
  facility,
  profile: combineReducers({
    auth,
    patient,
    user,
  }),
  capability,
  language,
  form,
  messageDisplayBar,
  personalContacts,
  appointment,
  careTeam,
  secureMessage,
  testResults,
  audit,
  contactUs,
  followUp,
  education,
  window,
  medicalNotes,
  treatmentSummary,
  questionnaires,
  localization,
  workflow,
  healthSummary,
  accountSettings,
  externalSystems,
  signUp,
  lookups,
  invitation,
  loadingIndicator,
});

export const logoutReducer = (state, action) => {
  let newState = state;
  if (action.type === LoginTypes.LOGOUT) {
    newState = {
      window: state.window,
    };
  }
  return newState;
};

const rootReducer = (state, action) => {
  const newState = logoutReducer(state, action);
  return appReducer(newState, action);
};

export default rootReducer;
